// extracted by mini-css-extract-plugin
export default {"badge":"ChannelBadge_badge__CnlQi","compact":"ChannelBadge_compact__ozKgO","label":"ChannelBadge_label__r8H7m"};